export default {
    titles: {
        title: 'Administrador de documentos',
        pending: 'Documentos ausentes',
        received: 'Documentos recebidos',
    },
    filters: {
        search: 'Pesquisar por nome do item de cobrança ou ID de referência',
        relation: 'Nível de relacionamento',
    },
    grid: {
        supportFileCode: 'Documento',
        fileName: 'Nome do arquivo',
        supportName: 'Nome do documento',
        accountRelation: 'Conta',
        chargeRelation: 'Descrição do Item de Cobrança',
        accountLevelDocument: 'Documento a nível de conta',
        nonPatientFound: 'Informação não disponível',
        patient: 'Nome do paciente',
        relation: 'Nível de relacionamento',
        referenceId: 'ID de referência',
        upload: 'Carregar',
        actions: 'Ações',
        uploadedFile: 'Arquivo enviado',
        required: 'Obrigatório',
        AiAnalysis: 'Análise I.A',
    },
    AiAnalysis: {
        tooltipHeader: `A I.A. analisa o documento e verifica se os dados estão corretos e fazem sentido. 
        O status indica o resultado e o nível de confiança dessa leitura.`,
        tooltipApproved: 'Tudo certo! Nenhuma divergência identificada.',
        tooltipRejected: 'Divergências identificadas. Clique para ver os detalhes.',
        tooltipPending: 'Sua análise está sendo processada. Aguarde alguns instantes.',
        noAiAnalysis: 'Não há analise',
        aiStatus: {
            approved: 'Aprovado',
            rejected: 'Reprovado',
            pending: 'Processando'
        }
    },
    relations: {
        account: 'Conta',
        charge: 'Item de cobrança',
        event: 'Atendimento',
        authorization: 'Autorização',
    },
    labels: {
        charge: 'Item de cobrança',
        dragAndDrop: 'Arraste e solte o arquivo aqui',
        uploadFile: 'Carregar arquivo',
        deleteFile: 'Deseja remover o documento?',
    },
    actions: {
        upload: 'Adicionar documento',
        replace: 'Subistituir documento',
        changeFile: 'Alterar arquivo',
        uploadInformation: 'Informação do documento',
        accept: 'Aceitar',
        cancel: 'Cancelar',
        downloadSelected: 'Baixar selecionados',
    },
    required: {
        yes: 'SIM',
        no: 'NÃO',
    },
    errors: {
        downloadSelectedError: 'Erro ao baixar os arquivos selecionados',
    },
}  